import { render, staticRenderFns } from "./StaticTextWidget.vue?vue&type=template&id=214c57c4&scoped=true&"
import script from "./StaticTextWidget.vue?vue&type=script&lang=js&"
export * from "./StaticTextWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214c57c4",
  null
  
)

export default component.exports